import { combineReducers } from 'redux';
import { boundaryGroupsReducer } from '../boundaryGroups/boundaryGroups.reducer';
import { boundaryItemsReducer } from '../boundaryItems/boundaryItems.reducer';

export const boundariesReducer = combineReducers({
  groups: boundaryGroupsReducer,
  items: boundaryItemsReducer,
});
